/**
 * Global vuex store.
 * This store is saved into sessionStorage and contains volatile data
 * that should disappear after logging out / closing the browser.
 */
import { Store } from 'vuex';

import ux from './ux.js';
import user from './user.js';
import facets from './facets.js';
import artvault from './artvault.js';
import pages from './pages.js';
// import organizations from './organizations.js';
import profileArticles from './profileArticles.js';
// import statistics from './statistics.js';

const createStore = (app, options) => {
    return new Store(
        Object.assign({
            modules: {
                ux: ux(app),
                user: user(app),
                facets: facets(app),
                artvault: artvault(app),
                pages: pages(app),
                // organizations,
                profileArticles: profileArticles(app)
                // statistics
            }
        }, options)
    );
};

export default createStore;
